import { type HgSupportedLanguage } from '@smg-real-estate/domus';
import type { GeoData, GeoExtraData } from '@smg-real-estate/geo-libs';

export interface SSRContext {
  error?: string;
  passThroughHeaders?: Record<string, string>;
  isTenantPlusSubscriber?: boolean;
  pageTrackingContext?: string;
  componentName?: string;
  fetchedSplitFlagSet?: string[];
  language?: HgSupportedLanguage;
  geoData: GeoData;
  geoExtraData: GeoExtraData;
  xHomegateIdentifier: string;
  layoutSolutionAgencyConfigurations?: any;
}

export enum SSRError {
  PageNotFound = 'PAGE_NOT_FOUND',
  DependencyFailedError = 'DEPENDENCY_FAILED_ERROR',
  OtherError = 'OTHER_ERROR',
}
